
<script>
  import { beforeUpdate } from 'svelte'
  import { stringifyStyle, calcPxNum } from './utils'
  export let height = undefined
  export let width = undefined
  export let wrap = false
  export let color = undefined
  export let size = '1rem'
  export let bold = false
  export let fontFamily = undefined
  export let fontWeight = undefined
  export let spacing = undefined
  export let lineHeight = undefined
  export let textOverflow = undefined
  export let overflow = 'hidden'
  export let decoration = undefined
  export let fontStyle = undefined
  export let cursor = undefined
  export let selectable = true
  export let hoverUnderline = false

  $: style = {
    height: calcPxNum(height),
    width: calcPxNum(width),
    color: color,
    font_size: calcPxNum(size),
    font_family: fontFamily,
    font_weight: fontWeight || (bold?'bold':'normal'),
    letter_spacing: calcPxNum(spacing),
    line_height: calcPxNum(lineHeight),
    text_overflow: textOverflow,
    overflow: overflow,
    white_space: wrap ? 'normal' : 'nowrap',
    text_decoration: decoration,
    __hover_decoration: hoverUnderline ? 'underline' : (decoration || 'none'),
    font_style: fontStyle,
    cursor: cursor,
    user_select: selectable ? null : 'none',
  }

  beforeUpdate(() => {
    // useful ??
  })
</script>

<style>
  span:hover {
    text-decoration: var(--hover-decoration)
  }
</style>

{#if wrap}
<p style="{stringifyStyle(style)}" on:click on:keypress>
  <slot></slot>
</p>
{:else}
<span style="{stringifyStyle(style)}" on:click on:keypress>
  <slot></slot>
</span>
{/if}